module.exports = __webpack_public_path__ + "img/jf.e423a9d7.jpg";